import { Box, BoxProps, ColorOptions, convertHexToRGBA, Spacer } from '@jfs/ui-new'
import { Icon } from '@jfs/ui-new/src/comps/IconNew'
import { Text, TextProps } from '@jfs/ui-new/src/comps/TextNew'
import { FC } from 'react'
import { Modal } from '../../comps/Modal'
import { useStores } from '../../data/store'
import { formatAmount, isIE } from '../../utils'

const ConvenienceFeeModal: FC<{
  showModal: boolean
  onDismiss: () => void
  convenienceFee: any
  transactionAmount: string
  amount: string
}> = ({
  showModal,
  onDismiss,
  convenienceFee,
  transactionAmount,
  amount,
}: {
  showModal: boolean
  onDismiss: () => void
  convenienceFee: any
  transactionAmount: string
  amount: string
}) => {
  const { theme } = useStores((root) => ({
    theme: root?.config?.merchantTheme,
  }))

  const style = styles(theme)

  return (
    <>
      <Modal
        type={'Bottom'}
        headerType="White_Bg"
        show={showModal}
        onDismiss={onDismiss}
        isFullWidth={true}
        theme={theme}
        containerTopPadding={isIE() ? 5 : undefined}>
        <>
          <Box paddingHorizontal={24} paddingVertical={32}>
            <Box flexDirection="row" justifyContent="space-between">
              <Box alignSelf="center">
                <Text {...style.modalText}>Amount breakup</Text>
              </Box>
              <Box
                onPress={onDismiss}
                width={30}
                height={30}
                borderRadius={15}
                justifyContent="center"
                alignItems="center"
                underlayColor={convertHexToRGBA(theme.brandColor, 50) as ColorOptions}>
                <Box
                  position="absolute"
                  top={0}
                  bottom={0}
                  left={0}
                  right={0}
                  borderRadius={15}
                  backgroundColor={theme?.headingText as ColorOptions}
                  opacity={0.15}
                />
                <Icon color={convertHexToRGBA(theme?.bodyTextColor, 50) as ColorOptions} id="CLOSE" size={16} />
              </Box>
            </Box>

            <ModalContent theme={theme} text="Order Amount" value={transactionAmount} />
            <ModalContent theme={theme} text="Conv. Fee" value={convenienceFee?.totalFee} />
            <ModalContent theme={theme} text="SGST" value={convenienceFee?.sgst} />
            <ModalContent theme={theme} text="CGST" value={convenienceFee?.cgst} />
            <ModalContent theme={theme} text="IGST" value={convenienceFee?.igst} />
            <ModalContent theme={theme} text="UGST" value={convenienceFee?.ugst} />
            <ModalContent theme={theme} text="TCS" value={convenienceFee?.tcs} />
            <ModalContent theme={theme} text="TDS" value={convenienceFee?.tds} />
            <Spacer size={20} />
            <Box {...style.separatorStyle} />
            <Spacer size={20} />
            <ModalContent theme={theme} text="Amount Payable" value={String(amount)} />
            <Spacer size={20} />
            <Box {...style.separatorStyle} />
            <Spacer size={10} />
            <Text {...style.noteText}>Note: Convenience fee is charged for selected payment mode.</Text>
          </Box>
        </>
      </Modal>
    </>
  )
}

const ModalContent = ({ theme, text, value }: { theme: any; text: string; value: string }) => {
  const style = styles(theme)
  console.log('ModalContent text', text, value)
  if (!value || Number(value) === 0) {
    return null
  }
  return (
    <>
      <Spacer size={20} />
      <Box {...style.modalContentContainer}>
        <Text {...style.modalText}>{text}</Text>
        <Text {...style.modalText}>{`₹${formatAmount(value)}`}</Text>
      </Box>
    </>
  )
}

const styles = (theme: any) => ({
  modalText: {
    fontSize: 14,
    fontWeight: '700',
    color: theme.bodyTextColor as ColorOptions,
  } as TextProps,
  modalContentContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  } as BoxProps,
  separatorStyle: {
    height: 1,
    backgroundColor: convertHexToRGBA(theme?.bodyTextColor, 10) as ColorOptions,
  } as BoxProps,
  noteText: {
    fontSize: 12,
    fontWeight: '500',
    color: theme.bodyTextColor as ColorOptions,
  } as TextProps,
})
export { ConvenienceFeeModal }
